import { IProps } from '@/blocks/MetaDataBlock/MetaDataBlock.interface';

export const defaultProps: IProps = {
  paddingTop: 'medium',
  paddingBottom: 'medium',
  items: [
    {
      title: 'Date',
      type: 'text',
      text: '28 October 2025',
    },
    {
      title: 'Category',
      type: 'pill',
      text: ['People & Communities', 'Type tag', 'Theme tag', 'marked'],
    },
    {
      title: 'Further reading',
      type: 'link',
      text: [
        {
          text: 'Download PDF',
          href: '#',
          target: '_blank',
          title: 'Download PDF',
          ariaLabel: 'Download PDF',
        },
        {
          text: 'Download link File',
          href: '#',
          target: '_blank',
          title: 'Download link File',
          ariaLabel: 'Download link File',
        },
      ],
    },
  ],
  shareInfo: {
    mailSubject: 'Share information about Story Detail Page SL QA Page',
    shareUrl:
      '/react-fe2-qa/stories-landing-page---qa/story-detail-page-sl-qa-page/',
    mailBody: 'Information about Story Detail Page SL QA Page',
    mailTo: 'test@test.com.au',
  },
  socialLinks: [
    // Use valid keys from IconName type
    { icon: 'facebook', url: '#', label: 'Facebook' },
    { icon: 'x-twitter', url: '#', label: 'Twitter' },
    { icon: 'linkedin', url: '#', label: 'LinkedIn' },
    { icon: 'instagram', url: '#', label: 'Instagram' },
    { icon: 'youtube', url: '#', label: 'YouTube' },
  ],
  buttons: [
    {
      children: 'Primary CTA',
      href: '#',
      variant: 'primary',
    },
    {
      children: 'Secondary',
      href: '#',
      variant: 'secondary',
    },
  ],
};

export const storiesDetailBlockProps: IProps = {
  paddingTop: 'medium',
  paddingBottom: 'medium',
  backgroundColor: 'primary-0',
  items: [
    {
      title: 'Date',
      type: 'text',
      text: '28 October 2025',
    },
    {
      title: 'Category',
      type: 'pill',
      text: [
        'Education, Training & Employment',
        'Community Development',
        'Alcohol & Other Drugs',
        'Justice & Corrections',
        'Youth Engagement & Transitions',
      ],
    },
    {
      title: 'Author',
      type: 'text',
      text: 'Serena Willaims',
    },
  ],
  shareInfo: {
    mailSubject: 'Share information about Story Detail Page SL QA Page',
    shareUrl:
      '/react-fe2-qa/stories-landing-page---qa/story-detail-page-sl-qa-page/',
    mailBody: 'Information about Story Detail Page SL QA Page',
  },
  socialLinks: [
    // Use valid keys from IconName type
    { icon: 'facebook', url: '#', label: 'Facebook' },
    { icon: 'x-twitter', url: '#', label: 'Twitter' },
    { icon: 'linkedin', url: '#', label: 'LinkedIn' },
    { icon: 'instagram', url: '#', label: 'Instagram' },
    { icon: 'youtube', url: '#', label: 'YouTube' },
  ],
  buttons: [
    {
      children: 'Donate',
      href: '#',
      variant: 'primary',
    },
    {
      children: 'Contact us',
      href: '#',
      variant: 'secondary',
    },
  ],
  alignment: 'vertical',
};
